var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClosebottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26274_207411)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 40,
    height: 40,
    rx: 18,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9797 23.967L29.8397 19.107C29.9489 18.9794 30.006 18.8154 29.9995 18.6476C29.993 18.4798 29.9235 18.3207 29.8047 18.2019C29.686 18.0832 29.5268 18.0136 29.3591 18.0072C29.1913 18.0007 29.0272 18.0578 28.8997 18.167L24.0397 23.027L19.1797 18.1603C19.0522 18.0511 18.8881 17.994 18.7203 18.0005C18.5525 18.007 18.3934 18.0765 18.2747 18.1953C18.1559 18.314 18.0864 18.4732 18.0799 18.6409C18.0734 18.8087 18.1305 18.9728 18.2397 19.1003L23.0997 23.967L18.233 28.827C18.1632 28.8867 18.1066 28.9603 18.0665 29.043C18.0265 29.1257 18.004 29.2158 18.0005 29.3076C17.997 29.3994 18.0124 29.491 18.0459 29.5765C18.0795 29.6621 18.1303 29.7398 18.1953 29.8047C18.2602 29.8697 18.3379 29.9205 18.4235 29.9541C18.509 29.9876 18.6006 30.0031 18.6924 29.9995C18.7842 29.996 18.8743 29.9735 18.957 29.9335C19.0397 29.8934 19.1133 29.8368 19.173 29.767L24.0397 24.907L28.8997 29.767C29.0272 29.8762 29.1913 29.9333 29.3591 29.9268C29.5268 29.9203 29.686 29.8507 29.8047 29.732C29.9235 29.6133 29.993 29.4541 29.9995 29.2863C30.006 29.1186 29.9489 28.9545 29.8397 28.827L24.9797 23.967Z",
    fill: "#575757"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26274_207411",
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_26274_207411"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26274_207411"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26274_207411",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosebottom);
export default __webpack_public_path__ + "static/media/Closebottom.ffab903ce84f9ea72f26c11a6d9f9e86.svg";
export { ForwardRef as ReactComponent };